import { Schema } from 'effect';

/**
 * Flexible DateTime schema that accepts both UTC and zoned ISO 8601 strings.
 *
 * Accepts:
 * - `2024-12-10T14:30:00Z` → DateTime.Utc
 * - `2024-12-10T14:30:00+01:00` → DateTime.Zoned (preserves offset)
 * - `2024-12-10T14:30:00` → DateTime.Utc (interpreted as UTC)
 *
 * DateTimeZoned is tried first to preserve timezone when explicit offset is provided.
 */
// v4: `Schema.DateTimeZoned` / `Schema.DateTimeUtc` now declare the DateTime
// types themselves (Encoded = Type). To parse from an ISO string, use the
// `FromString` companions whose Encoded side is `string`.
export const DateTimeFlexible = Schema.Union([
  Schema.DateTimeZonedFromString,
  Schema.DateTimeUtcFromString,
]).annotate({
  identifier: 'DateTimeFlexible',
  description: 'ISO 8601 datetime string with optional timezone (Z, offset, or none)',
});

export type DateTimeFlexible = Schema.Schema.Type<typeof DateTimeFlexible>;
